import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public ENV = environment.serviceEnv;
  public contactUsLink = environment.contactUsLink;
  private domain = environment.domain;

  get domainUrl(): string {
    return this.domain;
  }
}
